import { IState } from '../../config/rootReducer';
import LoginAction from '../Login/actions/LoginActionTypes';
import { ApplicationInsightInstance } from './AppInsight';

const switchForAllActions = (action, state: IState) => {
  if (typeof action === 'function') return;
  const { appInsights } = ApplicationInsightInstance;
  switch (action.type) {
    case LoginAction.Log.Out:
      appInsights.trackEvent(
        { name: 'LogoutEvent' },
        { email: state.profile.user.email, name: state.profile.client.name }
      );
      ApplicationInsightInstance.clearAuthenticatedUserContext();
      break;
    default:
      break;
  }
};

const AzureMonitoring = store => next => action => {
  switchForAllActions(action, store.getState());

  return next(action);
};

export default AzureMonitoring;
